import type { SceneNode } from "../scene/model";
import { activePage } from "../native/pages";
import { bounds } from "../native/geometry";
import { hasPaint } from "../native/appearance";
import { hasEffects } from "../native/effects";
import { effectBounds } from "./native-effects-raster";
import type { NativeFrame } from "./native-port";
/** Conservative world bounds include strokes, masks and effect padding. */
export function visibleNodes(
  frame: NativeFrame,
  accept: (node: SceneNode) => boolean = () => true,
) {
  const { camera, width, height } = frame;
  return activePage(frame.document).nodes.filter((node) => {
    if (!accept(node)) return false;
    if (node.appearance.visible === false || !hasPaint(node)) return false;
    const b = hasEffects(node) ? effectBounds(node) : bounds(node);
    return (
      (b.x + b.width) * camera.zoom + camera.x >= 0 &&
      (b.y + b.height) * camera.zoom + camera.y >= 0 &&
      b.x * camera.zoom + camera.x <= width &&
      b.y * camera.zoom + camera.y <= height
    );
  });
}
